import React from 'react';
import Layout from '../components/layout';
import Services from '../components/services';
import SimpleReactLightbox from 'simple-react-lightbox';

const ServicesPage = ({ location }) => {
	return (
		<Layout location={location}>
			<SimpleReactLightbox>
				<Services />
			</SimpleReactLightbox>
		</Layout>
	);
};

export default ServicesPage;
